<template>
  <div class="vx-col w-full mb-base">
    <h4 class="custom-title">Application Details</h4>
    <br>
    <div class="w-full">
      <vx-card title="Purchase Information">
        <div id="data-list-list-view" class="data-list-container">
          <div class="vx-col flex-1" style="overflow: scroll; width: 100%">
            <table class="vtable" >
              <tr>
                <td class="font-semibold">Product Name</td>
                <td>{{ product }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Brand</td>
                <td>{{ appDetails.brand }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Price Range</td>
                <td>{{ appDetails.price_range }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Suffix</td>
                <td>{{ appDetails.showroom.suffix }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Application Status</td>
                <td>
                  <vs-chip :color="getOrderStatusColor(appDetails.status)" class="product-order-status">
                    {{ appDetails.status == '2' ? 'New Application': appDetails.status == '3'? 'In-Process':
                    appDetails.status == '4' ? 'Halt' : appDetails.status == '5'? 'Accepted': appDetails.status == '6'? 'Rejected' : appDetails.status == '7'?'Reviewed':''
                    }}
                  </vs-chip>
                </td>
              </tr>
              <tr>
                <td class="font-semibold">Article</td>
                <td>{{ appDetails.product_master.article }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Article Description</td>
                <td>{{ appDetails.product_master.article_description }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Profit Center</td>
                <td>{{ appDetails.product_master.profit_center }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Profit Center Description</td>
                <td>{{ appDetails.product_master.profit_center_description }}</td>
              </tr>
              <tr>
                <td class="font-semibold">mdse_cat</td>
                <td>{{ appDetails.product_master.mdse_cat }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Merchandise Category</td>
                <td>{{ appDetails.product_master.merchandise_category }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Hire Price</td>
                <td>{{ appDetails.product_master.hire_price }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Down Payment</td>
                <td>{{ appDetails.product_master.down_payment }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Monthly Installment</td>
                <td>{{ appDetails.product_master.monthly_inst }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Pricing Date</td>
                <td>{{ appDetails.product_master.pricing_date }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Ho Comments</td>
                <td>{{ appDetails.ho_comments }}</td>
              </tr>
            </table>
          </div>
        </div>
      </vx-card>
    </div>
    <br/>
    <div class="w-full">
      <vx-card title="Applicant Personal Information" class="mb-base">
<!--        <template slot="actions">
          <vs-button color="rgb(0 121 193)"  icon-pack="feather" icon="icon-edit" @click="editPersonalInfo(appDetails.user.ekyc.id)">Update Personal Information</vs-button>
        </template>-->
        <!-- Avatar -->
        <div class="vx-row" style="overflow: scroll; width: 100%">
          <!-- Avatar Col -->
          <div class="vx-col" id="avatar-col">
            <div class="img-container mb-4">
              <img :src="appDetails.user.ekyc.parsonal.photo " class="rounded w-full" />
            </div>
          </div>

          <!-- Information - Col 1 -->
          <div class="vx-col flex-1" id="account-info-col-1">
            <table stripe class="vtable">
              <tr>
                <td class="font-semibold">First Name</td>
                <td>{{ appDetails.user.ekyc.parsonal.first_name }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Last Name</td>
                <td>{{ appDetails.user.ekyc.parsonal.last_name }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Father’s Name</td>
                <td>{{ appDetails.user.ekyc.parsonal.father_name }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Mother’s Name</td>
                <td>{{ appDetails.user.ekyc.parsonal.mother_name }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Spouse Name</td>
                <td>{{ appDetails.user.ekyc.parsonal.spouse_name }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Age</td>
                <td>{{ appDetails.user.ekyc.parsonal.age }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Marital Status</td>
                <td>{{ appDetails.user.ekyc.parsonal.marital_status }}</td>
              </tr>
            </table>
          </div>
          <!-- /Information - Col 1 -->

          <!-- Information - Col 2 -->
          <div class="vx-col flex-1" id="account-info-col-2">
            <table class="vtable">
              <tr>
                <td class="font-semibold">Gender</td>
                <td>{{ appDetails.user.ekyc.parsonal.gender }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Head of Household</td>
                <td>{{ appDetails.user.ekyc.parsonal.head_of_household === true?'Yes':'No' }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Education Level</td>
                <td>{{ appDetails.user.ekyc.parsonal.education_level }}</td>
              </tr>
              <tr>
                <td class="font-semibold">NID No</td>
                <td>{{ appDetails.user.ekyc.parsonal.nid }}</td>
              </tr>
              <tr v-if="appDetails.user.ekyc.parsonal.nid_front">
                <td class="font-semibold">NID Front</td>
                <td><img @click="popupActive=true" class="nidImg" :src="appDetails.user.ekyc.parsonal.nid_front" alt=""></td>
              </tr>
              <tr v-if="appDetails.user.ekyc.parsonal.nid_back">
                <td class="font-semibold">NID Back</td>
                <td><img @click="popupActive2=true" class="nidImg" style="margin-top: 5px" :src="appDetails.user.ekyc.parsonal.nid_back" alt=""></td>
              </tr>
              <template>
                <div class="demo-alignment">
                  <vs-popup class="holamundo" title="NID Front Image preview" :active.sync="popupActive">
                    <img class="nidImgPrev"  :src="appDetails.user.ekyc.parsonal.nid_front" alt="">
                  </vs-popup>
                </div>
              </template>
              <template>
                <div class="demo-alignment">
                  <vs-popup class="holamundo" title="NID Back Image preview" :active.sync="popupActive2">
                    <img class="nidImgPrev" :src="appDetails.user.ekyc.parsonal.nid_back" alt="">
                  </vs-popup>
                </div>
              </template>
            </table>
          </div>
          <!-- /Information - Col 2 -->
        </div>
        <!--<div class="vx-row">
          <div class="vx-col w-full text-right">
            <vs-checkbox
              v-model="appDetails.user.applicantPersonalCheck"
              class="mt-6 float-right"
            ></vs-checkbox>
          </div>
        </div>-->
      </vx-card>
      <vx-card title="Applicant Contact Information">
        <template slot="actions">
          <vs-button color="rgb(0 121 193)"  icon-pack="feather" icon="icon-edit" @click="editContactInfo(appDetails.user.ekyc.id)">Update Contact</vs-button>
        </template>
        <div class="vx-col flex-1" style="overflow: scroll">
          <table class="vtable" >
            <tr>
              <td class="font-semibold">Mobile</td>
              <td>{{ appDetails.user.ekyc.contact.mobile }}</td>
            </tr>
            <tr>
              <td class="font-semibold">Other Phone</td>
              <td>{{ appDetails.user.ekyc.contact.other_phone || '' }}</td>
            </tr>
            <tr>
              <td class="font-semibold">Email</td>
              <td>{{ appDetails.user.ekyc.contact.email || '' }}</td>
            </tr>
          </table>
        </div>
        <br/>
        <div class="vx-row">
          <div class="vx-col lg:w-1/2 w-full">
            <vx-card title="Present Address" class="mb-base" >
              <div class="" style="overflow: scroll; width: 100%">
                <table class="vtable" >
                  <tr>
                    <td class="font-semibold">Division</td>
                    <td>{{ appDetails.user.ekyc.contact.present_address.division }}</td>
                  </tr>
                  <tr>
                    <td class="font-semibold">District</td>
                    <td>{{ appDetails.user.ekyc.contact.present_address.district }}</td>
                  </tr>
                  <tr>
                    <td class="font-semibold">Thana</td>
                    <td>{{ appDetails.user.ekyc.contact.present_address.thana }}</td>
                  </tr>
                  <tr>
                    <td class="font-semibold">Apt#/ House#/ Road#/ Village#</td>
                    <td>{{ appDetails.user.ekyc.contact.present_address.address }}</td>
                  </tr>
                  <tr>
                    <td class="font-semibold">Nearby Famous Landmark</td>
                    <td>{{ appDetails.user.ekyc.contact.present_address.near_landmark }}</td>
                  </tr>
                  <tr>
                    <td class="font-semibold">Postal code</td>
                    <td>{{ appDetails.user.ekyc.contact.present_address.postal_code }}</td>
                  </tr>
                  <tr>
                    <td class="font-semibold">Household Type</td>
                    <td>{{ appDetails.user.ekyc.contact.present_address.house_hold_type == "tRented"? "Rented" : "Own Resident" }}</td>
                  </tr>
                  <tr>
                    <td class="font-semibold">Living in this address</td>
                    <td>
                      {{ appDetails.user.ekyc.contact.present_address.living_in_this_address.split(',')[0] }} year and {{ appDetails.user.ekyc.contact.present_address.living_in_this_address.split(',')[1] }} month</td>
                  </tr>
                </table>
              </div>
            </vx-card>
          </div>

          <div class="vx-col lg:w-1/2 w-full">
            <vx-card title="Permanent Address" class="mb-base">
              <div class="" style="overflow: scroll">
                <table class="vtable">
                  <tr>
                    <td class="font-semibold">Division</td>
                    <td>{{ appDetails.user.ekyc.contact.permanent_address.division }}</td>
                  </tr>
                  <tr>
                    <td class="font-semibold">District</td>
                    <td>{{ appDetails.user.ekyc.contact.permanent_address.district }}</td>
                  </tr>
                  <tr>
                    <td class="font-semibold">Thana</td>
                    <td>{{ appDetails.user.ekyc.contact.permanent_address.thana }}</td>
                  </tr>
                  <tr>
                    <td class="font-semibold">Apt#/ House#/ Road#/ Village#</td>
                    <td>{{ appDetails.user.ekyc.contact.permanent_address.address }}</td>
                  </tr>
                  <tr>
                    <td class="font-semibold">Nearby Famous Landmark</td>
                    <td>{{ appDetails.user.ekyc.contact.permanent_address.near_landmark }}</td>
                  </tr>
                  <tr>
                    <td class="font-semibold">Postal code</td>
                    <td>{{ appDetails.user.ekyc.contact.permanent_address.postal_code }}</td>
                  </tr>
                  <tr>
                    <td class="font-semibold">Household Type</td>
                    <td>{{ appDetails.user.ekyc.contact.permanent_address.house_hold_type == "pRented"? "Rented" : "Own Resident"  }}</td>
                  </tr>
                  <tr>
                    <td class="font-semibold">Living in this address</td>
                    <td>
                      {{ appDetails.user.ekyc.contact.permanent_address && appDetails.user.ekyc.contact.permanent_address.living_in_this_address.split(',')[0] }} year and {{ appDetails.user.ekyc.contact.permanent_address && appDetails.user.ekyc.contact.permanent_address.living_in_this_address.split(',')[1] }} month</td>
                  </tr>
                </table>
              </div>
            </vx-card>
          </div>
        </div>
        <!--<div class="vx-row">
          <div class="vx-col w-full text-right">
            <vs-checkbox
              v-model="appDetails.user.applicantContactCheck"
              class="mt-6 float-right"
            ></vs-checkbox>
          </div>
        </div>-->
      </vx-card>
      <br/>
      <!--      Occupation and dependant-->
      <div class="vx-row">
        <div  class="vx-col lg:w-1/2 w-full">
          <vx-card title="Applicant Occupation Information" class="mb-base">
            <template slot="actions">
              <vs-button color="rgb(0 121 193)"  icon-pack="feather" icon="icon-edit" @click="editOccupationInfo(appDetails.user.ekyc.id)">Update Occupation</vs-button>
            </template>
            <div class="" style="overflow: scroll">
              <table class="vtable">
                <tr>
                  <td class="font-semibold">Occupation Type</td>
                  <td>{{ appDetails.user.ekyc.occupation.occupation_type }}</td>
                </tr>
                <tr>
                  <td class="font-semibold">Organization Type</td>
                  <td>{{ appDetails.user.ekyc.occupation.occupation }}</td>
                </tr>
                <tr>
                  <td class="font-semibold">Monthly Income In BDT</td>
                  <td>{{ appDetails.user.ekyc.occupation.monthly_income }}</td>
                </tr>
                <tr>
                  <td class="font-semibold">Name of the Office/Business</td>
                  <td>{{ appDetails.user.ekyc.occupation.name_of_Office_or_business }}</td>
                </tr>
                <tr>
                  <td class="font-semibold">Designation</td>
                  <td>{{ appDetails.user.ekyc.occupation.designation }}</td>
                </tr>
                <tr>
                  <td class="font-semibold">Job length</td>
                  <td>
                    {{ appDetails.user.ekyc.occupation.job_length.split(',')[0] }} year and {{
                    appDetails.user.ekyc.occupation.job_length.split(',')[1] }} month
                  </td>
                </tr>
                <tr>
                  <td class="font-semibold">Division</td>
                  <td>{{ appDetails.user.ekyc.occupation.occupation_address.division }}</td>
                </tr>
                <tr>
                  <td class="font-semibold">District</td>
                  <td>{{ appDetails.user.ekyc.occupation.occupation_address.district }}</td>
                </tr>
                <tr>
                  <td class="font-semibold">Thana</td>
                  <td>{{ appDetails.user.ekyc.occupation.occupation_address.thana }}</td>
                </tr>
                <tr>
                  <td class="font-semibold">Office Area</td>
                  <td>{{ appDetails.user.ekyc.occupation.occupation_address.office_area }}</td>
                </tr>
                <tr>
                  <td class="font-semibold">Apt#/House#/Road#/Village#</td>
                  <td>{{ appDetails.user.ekyc.occupation.occupation_address.address }}</td>
                </tr>
                <tr>
                  <td class="font-semibold">Postal code</td>
                  <td>{{ appDetails.user.ekyc.occupation.occupation_address.postal_code }}</td>
                </tr>
              </table>
            </div>
            <!--<div class="vx-row">
              <div class="vx-col w-full text-right">
                <vs-checkbox
                  v-model="appDetails.user.applicantOccupationCheck"
                  class="mt-6 float-right"
                ></vs-checkbox>
              </div>
            </div>-->
          </vx-card>
        </div>

        <div class="vx-col lg:w-1/2 w-full">
          <vx-card
            title="Applicant Dependent Information"
            class="mb-base"
          >
            <template slot="actions">
              <vs-button color="rgb(0 121 193)"  icon-pack="feather" icon="icon-edit" @click="editDependentInfo(appDetails.user.ekyc.id)">Update Dependent Information</vs-button>
            </template>
            <table class="vtable">
              <tr>
                <td class="font-semibold">
                  No. of Children living with you
                </td>
                <td>&nbsp; &nbsp;{{ appDetails.user.ekyc.dependent.number_of_child }}</td>
              </tr>
              <tr>
                <td class="font-semibold">
                  No. of dependent living with you
                </td>
                <td>&nbsp; &nbsp;{{ appDetails.user.ekyc.dependent.number_of_dependent }}</td>
              </tr>
              <br/>
            </table>
            <table
              stripe
              style="max-height: 235px; overflow: scroll; width: 100%"
            >
              <thead slot="thead">
              <th>Relation</th>
              <th>Name</th>
              <th>Age</th>
              </thead>
              <tbody>
              <tr
                v-for="(dependent, indextr) in appDetails.user.ekyc.dependent.depandant_details"
                :key="indextr"
              >
                <td>
                  {{ dependent.relation }}
                </td>
                <td>
                  {{ dependent.name }}
                </td>
                <td>
                  {{ dependent.age }}
                </td>
              </tr>
              </tbody>
            </table>
            <!--<div class="vx-col w-full text-right">
              <vs-checkbox
                v-model="appDetails.user.applicantDepandentCheck"
                class="mt-6 float-right"
              ></vs-checkbox>
            </div>-->
          </vx-card>
        </div>
      </div>
      <br/>
    </div>
    <br/>
    <div class="w-full">
      <h4 class="custom-title">Guarantor Information -{{guarantorOne.ekyc.parsonal.first_name}}</h4>
      <br>
      <div class="w-full" >
        <vx-card title="Personal Information" class="mb-base">
<!--          <template slot="actions">
            <vs-button color="rgb(0 121 193)"  icon-pack="feather" icon="icon-edit" @click="editPersonalInfo(guarantorOne.ekyc.id)">Update Personal Information</vs-button>
          </template>-->
          <!-- Avatar -->
          <div class="vx-row">
            <!-- Avatar Col -->
            <div class="vx-col" id="avatar-col">
              <div class="img-container mb-4">
                <img :src="guarantorOne.ekyc.parsonal.photo" class="rounded w-full" />
              </div>
            </div>
            <!-- Information - Col 1 -->
            <div class="vx-col flex-1" id="account-info-col-1">
              <table class="vtable">
                <tr>
                  <td class="font-semibold">First Name</td>
                  <td>{{ guarantorOne.ekyc.parsonal.first_name }}</td>
                </tr>
                <tr>
                  <td class="font-semibold">Last Name</td>
                  <td>{{ guarantorOne.ekyc.parsonal.last_name }}</td>
                </tr>
                <tr>
                  <td class="font-semibold">Father’s Name</td>
                  <td>{{ guarantorOne.ekyc.parsonal.father_name }}</td>
                </tr>
                <tr>
                  <td class="font-semibold">Mother’s Name</td>
                  <td>{{ guarantorOne.ekyc.parsonal.mother_name }}</td>
                </tr>
                <tr>
                  <td class="font-semibold">Spouse Name</td>
                  <td>{{ guarantorOne.ekyc.parsonal.spouse_name }}</td>
                </tr>
                <tr>
                  <td class="font-semibold">Age</td>
                  <td>{{ guarantorOne.ekyc.parsonal.age }}</td>
                </tr>
                <tr>
                  <td class="font-semibold">Marital Status</td>
                  <td>{{ guarantorOne.ekyc.parsonal.marital_status }}</td>
                </tr>
              </table>
            </div>
            <!-- /Information - Col 1 -->

            <!-- Information - Col 2 -->
            <div
              class="vx-col flex-1"
              id="account-info-col-2"
            >
              <table class="vtable">
                <tr>
                  <td class="font-semibold">Gender</td>
                  <td>{{ guarantorOne.ekyc.parsonal.gender }}</td>
                </tr>
                <tr>
                  <td class="font-semibold">Head of Household</td>
                  <td>{{ guarantorOne.ekyc.parsonal.head_of_household === true?'Yes':'No' }}</td>
                </tr>
                <tr>
                  <td class="font-semibold">Education Level</td>
                  <td>{{ guarantorOne.ekyc.parsonal.education_level }}</td>
                </tr>
                <tr>
                  <td class="font-semibold">NID No</td>
                  <td>{{ guarantorOne.ekyc.parsonal.nid }}</td>
                </tr>
                <tr v-if="guarantorOne.ekyc.parsonal.nid_front">
                  <td class="font-semibold">NID Front</td>
                  <td><img @click="popupActive3=true" class="nidImg" :src="guarantorOne.ekyc.parsonal.nid_front" alt=""></td>
                </tr>
                <tr v-if="guarantorOne.ekyc.parsonal.nid_back">
                  <td class="font-semibold">NID Back</td>
                  <td><img @click="popupActive4=true" class="nidImg" :src="guarantorOne.ekyc.parsonal.nid_back" alt=""></td>
                </tr>
                <template>
                  <div class="demo-alignment">
                    <vs-popup class="holamundo" title="NID Front Image preview" :active.sync="popupActive3">
                      <img class="nidImgPrev"  :src="guarantorOne.ekyc.parsonal.nid_front" alt="">
                    </vs-popup>
                  </div>
                </template>
                <template>
                  <div class="demo-alignment">
                    <vs-popup class="holamundo" title="NID Back Image preview" :active.sync="popupActive4">
                      <img class="nidImgPrev" :src="guarantorOne.ekyc.parsonal.nid_back" alt="">
                    </vs-popup>
                  </div>
                </template>
                <tr>
                  <td class="font-semibold">Relationship</td>
                  <td>{{ guarantorOne.ekyc.parsonal.relationship }}</td>
                </tr>
              </table>
            </div>
            <!-- /Information - Col 2 -->
          </div>
          <!--<div class="vx-row">
            <div class="vx-col w-full text-right">
              <vs-checkbox
                name="gOnePersonalCheck[indextr]"
                v-model="guarantorList[indextr].gOnePersonalCheck"
                class="float-right"
              ></vs-checkbox>
              <vs-button
                color="success"
                class="mr-3 mb-2 float-right"
                size="small"
                @click="
                  updatePersonalInfo(
                    guarantor.id,
                    guarantor.ekyc.id,
                    purchaseApp.id
                  )
                "
              >Edit Personal Information
              </vs-button>
            </div>
          </div>-->
        </vx-card>
        <vx-card title="Contact Information">
          <template slot="actions">
            <vs-button color="rgb(0 121 193)"  icon-pack="feather" icon="icon-edit" @click="editContactInfo(guarantorOne.ekyc.id)">Update Contact</vs-button>
          </template>
          <div class="vx-col flex-1" style="overflow: scroll">
            <table class="vtable">
              <tr>
                <td class="font-semibold">Mobile</td>
                <td>{{ guarantorOne.ekyc.contact.mobile }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Other Phone</td>
                <td>{{ guarantorOne.ekyc.contact.other_phone || '' }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Email</td>
                <td>{{ guarantorOne.ekyc.contact.email || '' }}</td>
              </tr>
            </table>
          </div>
          <br/>
          <div  class="vx-row">
            <div class="vx-col lg:w-1/2 w-full">
              <vx-card title="Present Address" class="mb-base">
                <div class="" style="overflow: scroll">
                  <table class="vtable">
                    <tr>
                      <td class="font-semibold">Division</td>
                      <td>
                        {{ guarantorOne.ekyc.contact.present_address.division }}
                      </td>
                    </tr>
                    <tr>
                      <td class="font-semibold">District</td>
                      <td>
                        {{ guarantorOne.ekyc.contact.present_address.district }}
                      </td>
                    </tr>
                    <tr>
                      <td class="font-semibold">Thana</td>
                      <td>
                        {{ guarantorOne.ekyc.contact.present_address.thana }}
                      </td>
                    </tr>
                    <tr>
                      <td class="font-semibold">Apt#/ House#/ Road#/ Village#</td>
                      <td>{{ guarantorOne.ekyc.contact.present_address.address }}</td>
                    </tr>
                    <tr>
                      <td class="font-semibold">Nearby Famous Landmark</td>
                      <td>
                        {{ guarantorOne.ekyc.contact.present_address.near_landmark }}
                      </td>
                    </tr>
                    <tr>
                      <td class="font-semibold">Postal code</td>
                      <td>
                        {{ guarantorOne.ekyc.contact.present_address.postal_code}}
                      </td>
                    </tr>
                    <tr>
                      <td class="font-semibold">Household Type</td>
                      <td>
                        {{ guarantorOne.ekyc.contact.present_address.house_hold_type  === "tOwnResident"? "Own Resident" : "Rented"}}
                      </td>
                    </tr>
                    <tr>
                      <td class="font-semibold">Living in this address</td>
                      <td>
                        {{ guarantorOne.ekyc.contact.present_address.living_in_this_address.split(',')[0] }} year and {{ guarantorOne.ekyc.contact.present_address.living_in_this_address.split(',')[1] }} month
                      </td>
                    </tr>
                  </table>
                </div>
              </vx-card>
            </div>

            <div class="vx-col lg:w-1/2 w-full">
              <vx-card title="Permanent Address" class="mb-base">
                <div class="" style="overflow: scroll">
                  <table class="vtable">
                    <tr>
                      <td class="font-semibold">Division</td>
                      <td>
                        {{guarantorOne.ekyc.contact.permanent_address.division}}
                      </td>
                    </tr>
                    <tr>
                      <td class="font-semibold">District</td>
                      <td>
                        {{guarantorOne.ekyc.contact.permanent_address.district}}
                      </td>
                    </tr>
                    <tr>
                      <td class="font-semibold">Thana</td>
                      <td>
                        {{ guarantorOne.ekyc.contact.permanent_address.thana }}
                      </td>
                    </tr>
                    <tr>
                      <td class="font-semibold">
                        Apt#/ House#/ Road#/ Village#
                      </td>
                      <td>
                        {{guarantorOne.ekyc.contact.permanent_address.address}}
                      </td>
                    </tr>
                    <tr>
                      <td class="font-semibold">Nearby Famous Landmark</td>
                      <td>
                        {{guarantorOne.ekyc.contact.permanent_address.near_landmark}}
                      </td>
                    </tr>
                    <tr>
                      <td class="font-semibold">Postal code</td>
                      <td>
                        {{guarantorOne.ekyc.contact.permanent_address.postal_code}}
                      </td>
                    </tr>
                    <tr>
                      <td class="font-semibold">Household Type</td>
                      <td>
                        {{guarantorOne.ekyc.contact.permanent_address.house_hold_type  === "pOwnResident"? "Own Resident" : "Rented"}}
                      </td>
                    </tr>
                    <tr>
                      <td class="font-semibold">Living in this address</td>
                      <td>
                        {{ guarantorOne.ekyc.contact.permanent_address.living_in_this_address.split(',')[0] }} year and {{ guarantorOne.ekyc.contact.permanent_address.living_in_this_address.split(',')[1] }} month
                      </td>
                    </tr>
                  </table>
                </div>
              </vx-card>
            </div>
          </div>
          <!--<div v-if="purchaseApp.status !== 5" class="vx-row">
            <div class="vx-col w-full text-right">
              <vs-checkbox
                v-model="guarantorList[indextr].gOneContactCheck"
                class="float-right"
              ></vs-checkbox>
              <vs-button
                color="success"
                class="mr-3 mb-2 float-right"
                size="small"
                @click="
                  updateContactInfo(
                    guarantor.id,
                    guarantor.ekyc.id,
                    purchaseApp.id
                  )
                "
              >Edit Contact Information
              </vs-button>
            </div>
          </div>-->
        </vx-card>
        <br/>
        <!--      Occupation and dependant-->
        <div class="vx-row">
          <div  class="vx-col lg:w-1/2 w-full">
            <vx-card title="Occupation Information" class="mb-base" >
              <template slot="actions">
                <vs-button color="rgb(0 121 193)"  icon-pack="feather" icon="icon-edit" @click="editOccupationInfo(guarantorOne.ekyc.id)">Update Occupation</vs-button>
              </template>
              <div class="" style="overflow: scroll">
                <table class="vtable">
                  <tr>
                    <td class="font-semibold">Occupation Type</td>
                    <td>{{ guarantorOne.ekyc.occupation.occupation_type }}</td>
                  </tr>
                  <tr>
                    <td class="font-semibold">Organization Type</td>
                    <td>{{ guarantorOne.ekyc.occupation.occupation }}</td>
                  </tr>
                  <tr>
                    <td class="font-semibold">Monthly Income In BDT</td>
                    <td>{{ guarantorOne.ekyc.occupation.monthly_income }}</td>
                  </tr>
                  <tr>
                    <td class="font-semibold">
                      Name of the Office/Business
                    </td>
                    <td>
                      {{guarantorOne.ekyc.occupation.name_of_Office_or_business}}
                    </td>
                  </tr>
                  <tr>
                    <td class="font-semibold">Designation</td>
                    <td>{{ guarantorOne.ekyc.occupation.designation }}</td>
                  </tr>
                  <tr>
                    <td class="font-semibold">Job length</td>
                    <td>
                      {{ guarantorOne.ekyc.occupation.job_length.split(',')[0] }} year and {{
                      guarantorOne.ekyc.occupation.job_length.split(',')[1] }} month
                    </td>
                  </tr>
                  <tr>
                    <td class="font-semibold">Division</td>
                    <td>
                      {{guarantorOne.ekyc.occupation.occupation_address.division}}
                    </td>
                  </tr>
                  <tr>
                    <td class="font-semibold">District</td>
                    <td>
                      {{guarantorOne.ekyc.occupation.occupation_address.district}}
                    </td>
                  </tr>
                  <tr>
                    <td class="font-semibold">Thana</td>
                    <td>
                      {{guarantorOne.ekyc.occupation.occupation_address.thana}}
                    </td>
                  </tr>
                  <tr>
                    <td class="font-semibold">Office Area</td>
                    <td>
                      {{guarantorOne.ekyc.occupation.occupation_address.office_area}}
                    </td>
                  </tr>
                  <tr>
                    <td class="font-semibold">
                      Apt#/ House#/ Road#/ Village#
                    </td>
                    <td>
                      {{guarantorOne.ekyc.occupation.occupation_address.address}}
                    </td>
                  </tr>
                  <tr>
                    <td class="font-semibold">Postal code</td>
                    <td>
                      {{guarantorOne.ekyc.occupation.occupation_address.postal_code}}
                    </td>
                  </tr>
                </table>
              </div>
              <!--<div v-if="purchaseApp.status !== 5" class="vx-row">
                <div class="vx-col w-full text-right">
                  <vs-checkbox
                    v-model="guarantorList[indextr].gOneOccupationCheck"
                    class="float-right"
                  ></vs-checkbox>
                  <vs-button
                    color="success"
                    class="mr-3 mb-2 float-right"
                    size="small"
                    @click="
                      updateOccupationInfo(
                        guarantor.id,
                        guarantor.ekyc.id,
                        purchaseApp.id
                      )
                    "
                  >Edit Occupation Information
                  </vs-button>
                </div>
              </div>-->
            </vx-card>
          </div>

          <div class="vx-col lg:w-1/2 w-full" >
            <vx-card title="Dependent Information" class="mb-base" >
              <template slot="actions">
                <vs-button color="rgb(0 121 193)"  icon-pack="feather" icon="icon-edit" @click="editDependentInfo(guarantorOne.ekyc.id)">Update Dependent Information</vs-button>
              </template>
              <table class="vtable">
                <tr>
                  <td class="font-semibold">
                    No. of Children living with you
                  </td>
                  <td>&nbsp; &nbsp;{{ guarantorOne.ekyc.dependent.number_of_child }}</td>
                </tr>
                <tr>
                  <td class="font-semibold">
                    No. of dependent living with you
                  </td>
                  <td>
                    &nbsp; &nbsp;{{ guarantorOne.ekyc.dependent.number_of_dependent }}
                  </td>
                </tr>
                <br/>
              </table>
              <div  class="">
                <table  stripe   style="max-height: 235px; overflow: scroll; width: 100%">
                  <thead slot="thead">
                  <th>Relation</th>
                  <th>Name</th>
                  <th>Age</th>
                  </thead>
                  <tbody>
                  <tr
                    v-for="(dependent, indextr) in guarantorOne.ekyc.dependent.depandant_details" :key="indextr">
                    <td>
                      {{ dependent.relation }}
                    </td>
                    <td>
                      {{ dependent.name }}
                    </td>
                    <td>
                      {{ dependent.age }}
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <br/>
              <!--<div v-if="purchaseApp.status !== 5" class="vx-col w-full text-right">
                <vs-checkbox
                  v-model="guarantorList[indextr].gOneDependentCheck"
                  class="float-right"
                ></vs-checkbox>
                <vs-button
                  color="success"
                  class="mr-3 mb-2 float-right"
                  size="small"
                  @click="
                    updateDependentInfo(
                      guarantor.id,
                      guarantor.ekyc.id,
                      purchaseApp.id
                    )
                  "
                >Edit Dependent Information
                </vs-button>
              </div>-->
              <br/>
            </vx-card>
          </div>
        </div>
        <!-- Showroom and Product  -->

        <br/>

        <!--        Guarantor-->
      </div>
      <div class="w-full" >
        <h4 class="custom-title">Guarantor Information -{{guarantorTwo.ekyc.parsonal.first_name}}</h4>
        <br/>
        <vx-card title="Personal Information" class="mb-base">
<!--          <template slot="actions">
            <vs-button color="rgb(0 121 193)"  icon-pack="feather" icon="icon-edit" @click="editPersonalInfo(guarantorTwo.ekyc.id)">Update Personal Information</vs-button>
          </template>-->
          <!-- Avatar -->
          <div class="vx-row">
            <!-- Avatar Col -->
            <div class="vx-col" id="avatar-col">
              <div class="img-container mb-4">
                <img :src="guarantorTwo.ekyc.parsonal.photo" class="rounded w-full" />
              </div>
            </div>
            <!-- Information - Col 1 -->
            <div class="vx-col flex-1">
              <table class="vtable">
                <tr>
                  <td class="font-semibold">First Name</td>
                  <td>{{ guarantorTwo.ekyc.parsonal.first_name }}</td>
                </tr>
                <tr>
                  <td class="font-semibold">Last Name</td>
                  <td>{{ guarantorTwo.ekyc.parsonal.last_name }}</td>
                </tr>
                <tr>
                  <td class="font-semibold">Father’s Name</td>
                  <td>{{ guarantorTwo.ekyc.parsonal.father_name }}</td>
                </tr>
                <tr>
                  <td class="font-semibold">Mother’s Name</td>
                  <td>{{ guarantorTwo.ekyc.parsonal.mother_name }}</td>
                </tr>
                <tr>
                  <td class="font-semibold">Spouse Name</td>
                  <td>{{ guarantorTwo.ekyc.parsonal.spouse_name }}</td>
                </tr>
                <tr>
                  <td class="font-semibold">Age</td>
                  <td>{{ guarantorTwo.ekyc.parsonal.age }}</td>
                </tr>
                <tr>
                  <td class="font-semibold">Marital Status</td>
                  <td>{{ guarantorTwo.ekyc.parsonal.marital_status }}</td>
                </tr>
              </table>
            </div>
            <!-- /Information - Col 1 -->

            <!-- Information - Col 2 -->
            <div
              class="vx-col flex-1"
              id="account-info-col-2"
            >
              <table class="vtable">
                <tr>
                  <td class="font-semibold">Gender</td>
                  <td>{{ guarantorTwo.ekyc.parsonal.gender }}</td>
                </tr>
                <tr>
                  <td class="font-semibold">Head of Household</td>
                  <td>{{ guarantorTwo.ekyc.parsonal.head_of_household === true?'Yes':'No' }}</td>
                </tr>
                <tr>
                  <td class="font-semibold">Education Level</td>
                  <td>{{ guarantorTwo.ekyc.parsonal.education_level }}</td>
                </tr>
                <tr>
                  <td class="font-semibold">NID No</td>
                  <td>{{ guarantorTwo.ekyc.parsonal.nid }}</td>
                </tr>
                <tr v-if="guarantorTwo.ekyc.parsonal.nid_front">
                  <td class="font-semibold">NID Front</td>
                  <td><img @click="popupActive5=true" class="nidImg" :src="guarantorTwo.ekyc.parsonal.nid_front" alt=""></td>
                </tr>
                <tr v-if="guarantorTwo.ekyc.parsonal.nid_back">
                  <td class="font-semibold">NID Back</td>
                  <td><img @click="popupActive6=true" class="nidImg" :src="guarantorTwo.ekyc.parsonal.nid_back" alt=""></td>
                </tr>
                <template>
                  <div class="demo-alignment">
                    <vs-popup class="holamundo" title="NID Front Image preview" :active.sync="popupActive5">
                      <img class="nidImgPrev"  :src="guarantorTwo.ekyc.parsonal.nid_front" alt="">
                    </vs-popup>
                  </div>
                </template>
                <template>
                  <div class="demo-alignment">
                    <vs-popup class="holamundo" title="NID Back Image preview" :active.sync="popupActive6">
                      <img class="nidImgPrev" :src="guarantorTwo.ekyc.parsonal.nid_back" alt="">
                    </vs-popup>
                  </div>
                </template>
                <tr>
                  <td class="font-semibold">Relationship</td>
                  <td>{{ guarantorTwo.ekyc.parsonal.relationship }}</td>
                </tr>
              </table>
            </div>
            <!-- /Information - Col 2 -->
          </div>
          <!--<div class="vx-row">
            <div class="vx-col w-full text-right">
              <vs-checkbox
                name="gOnePersonalCheck[indextr]"
                v-model="guarantorList[indextr].gOnePersonalCheck"
                class="float-right"
              ></vs-checkbox>
              <vs-button
                color="success"
                class="mr-3 mb-2 float-right"
                size="small"
                @click="
                  updatePersonalInfo(
                    guarantor.id,
                    guarantor.ekyc.id,
                    purchaseApp.id
                  )
                "
              >Edit Personal Information
              </vs-button>
            </div>
          </div>-->
        </vx-card>
        <vx-card title="Contact Information">
          <template slot="actions">
            <vs-button color="rgb(0 121 193)"  icon-pack="feather" icon="icon-edit" @click="editContactInfo(guarantorTwo.ekyc.id)">Update Contact</vs-button>
          </template>
          <div class="vx-col flex-1" style="overflow: scroll">
            <table class="vtable">
              <tr>
                <td class="font-semibold">Mobile</td>
                <td>{{ guarantorTwo.ekyc.contact.mobile }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Other Phone</td>
                <td>{{ guarantorTwo.ekyc.contact.other_phone || '' }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Email</td>
                <td>{{ guarantorTwo.ekyc.contact.email || '' }}</td>
              </tr>
            </table>
          </div>
          <br/>
          <div  class="vx-row">
            <div class="vx-col lg:w-1/2 w-full">
              <vx-card title="Present Address" class="mb-base">
                <div class="" style="overflow: scroll">
                  <table class="vtable">
                    <tr>
                      <td class="font-semibold">Division</td>
                      <td>
                        {{ guarantorTwo.ekyc.contact.present_address.division }}
                      </td>
                    </tr>
                    <tr>
                      <td class="font-semibold">District</td>
                      <td>
                        {{ guarantorTwo.ekyc.contact.present_address.district }}
                      </td>
                    </tr>
                    <tr>
                      <td class="font-semibold">Thana</td>
                      <td>
                        {{ guarantorTwo.ekyc.contact.present_address.thana }}
                      </td>
                    </tr>
                    <tr>
                      <td class="font-semibold">Apt#/ House#/ Road#/ Village#</td>
                      <td>{{ guarantorTwo.ekyc.contact.present_address.address }}</td>
                    </tr>
                    <tr>
                      <td class="font-semibold">Nearby Famous Landmark</td>
                      <td>
                        {{ guarantorTwo.ekyc.contact.present_address.near_landmark }}
                      </td>
                    </tr>
                    <tr>
                      <td class="font-semibold">Postal code</td>
                      <td>
                        {{ guarantorTwo.ekyc.contact.present_address.postal_code}}
                      </td>
                    </tr>
                    <tr>
                      <td class="font-semibold">Household Type</td>
                      <td>
                        {{ guarantorTwo.ekyc.contact.present_address.house_hold_type  === "tOwnResident"? "Own Resident" : "Rented"}}
                      </td>
                    </tr>
                    <tr>
                      <td class="font-semibold">Living in this address</td>
                      <td>
                        {{ guarantorTwo.ekyc.contact.present_address.living_in_this_address.split(',')[0] }} year and {{ guarantorTwo.ekyc.contact.present_address.living_in_this_address.split(',')[1] }} month
                      </td>
                    </tr>
                  </table>
                </div>
              </vx-card>
            </div>

            <div class="vx-col lg:w-1/2 w-full">
              <vx-card title="Permanent Address" class="mb-base">
                <div class="" style="overflow: scroll">
                  <table class="vtable">
                    <tr>
                      <td class="font-semibold">Division</td>
                      <td>
                        {{guarantorTwo.ekyc.contact.permanent_address.division}}
                      </td>
                    </tr>
                    <tr>
                      <td class="font-semibold">District</td>
                      <td>
                        {{guarantorTwo.ekyc.contact.permanent_address.district}}
                      </td>
                    </tr>
                    <tr>
                      <td class="font-semibold">Thana</td>
                      <td>
                        {{ guarantorTwo.ekyc.contact.permanent_address.thana }}
                      </td>
                    </tr>
                    <tr>
                      <td class="font-semibold">
                        Apt#/ House#/ Road#/ Village#
                      </td>
                      <td>
                        {{guarantorTwo.ekyc.contact.permanent_address.address}}
                      </td>
                    </tr>
                    <tr>
                      <td class="font-semibold">Nearby Famous Landmark</td>
                      <td>
                        {{guarantorTwo.ekyc.contact.permanent_address.near_landmark}}
                      </td>
                    </tr>
                    <tr>
                      <td class="font-semibold">Postal code</td>
                      <td>
                        {{guarantorTwo.ekyc.contact.permanent_address.postal_code}}
                      </td>
                    </tr>
                    <tr>
                      <td class="font-semibold">Household Type</td>
                      <td>
                        {{guarantorTwo.ekyc.contact.permanent_address.house_hold_type  === "pOwnResident"? "Own Resident" : "Rented"}}
                      </td>
                    </tr>
                    <tr>
                      <td class="font-semibold">Living in this address</td>
                      <td>
                        {{ guarantorTwo.ekyc.contact.permanent_address.living_in_this_address.split(',')[0] }} year and {{ guarantorTwo.ekyc.contact.permanent_address.living_in_this_address.split(',')[1] }} month
                      </td>
                    </tr>
                  </table>
                </div>
              </vx-card>
            </div>
          </div>
          <!--<div v-if="purchaseApp.status !== 5" class="vx-row">
            <div class="vx-col w-full text-right">
              <vs-checkbox
                v-model="guarantorList[indextr].gOneContactCheck"
                class="float-right"
              ></vs-checkbox>
              <vs-button
                color="success"
                class="mr-3 mb-2 float-right"
                size="small"
                @click="
                  updateContactInfo(
                    guarantor.id,
                    guarantor.ekyc.id,
                    purchaseApp.id
                  )
                "
              >Edit Contact Information
              </vs-button>
            </div>
          </div>-->
        </vx-card>
        <br/>
        <!--      Occupation and dependant-->
        <div class="vx-row">
          <div  class="vx-col lg:w-1/2 w-full">
            <vx-card title="Occupation Information" class="mb-base" >
              <template slot="actions">
                <vs-button color="rgb(0 121 193)"  icon-pack="feather" icon="icon-edit" @click="editOccupationInfo(guarantorTwo.ekyc.id)">Update Occupation</vs-button>
              </template>
              <div class="" style="overflow: scroll">
                <table class="vtable">
                  <tr>
                    <td class="font-semibold">Occupation Type</td>
                    <td>{{ guarantorTwo.ekyc.occupation.occupation_type }}</td>
                  </tr>
                  <tr>
                    <td class="font-semibold">Organization Type</td>
                    <td>{{ guarantorTwo.ekyc.occupation.occupation }}</td>
                  </tr>
                  <tr>
                    <td class="font-semibold">Monthly Income In BDT</td>
                    <td>{{ guarantorTwo.ekyc.occupation.monthly_income }}</td>
                  </tr>
                  <tr>
                    <td class="font-semibold">
                      Name of the Office/Business
                    </td>
                    <td>
                      {{guarantorTwo.ekyc.occupation.name_of_Office_or_business}}
                    </td>
                  </tr>
                  <tr>
                    <td class="font-semibold">Designation</td>
                    <td>{{ guarantorTwo.ekyc.occupation.designation }}</td>
                  </tr>
                  <tr>
                    <td class="font-semibold">Job length</td>
                    <td>
                      {{ guarantorTwo.ekyc.occupation.job_length.split(',')[0] }} year and {{
                      guarantorTwo.ekyc.occupation.job_length.split(',')[1] }} month
                    </td>
                  </tr>
                  <tr>
                    <td class="font-semibold">Division</td>
                    <td>
                      {{guarantorTwo.ekyc.occupation.occupation_address.division}}
                    </td>
                  </tr>
                  <tr>
                    <td class="font-semibold">District</td>
                    <td>
                      {{guarantorTwo.ekyc.occupation.occupation_address.district}}
                    </td>
                  </tr>
                  <tr>
                    <td class="font-semibold">Thana</td>
                    <td>
                      {{guarantorTwo.ekyc.occupation.occupation_address.thana}}
                    </td>
                  </tr>
                  <tr>
                    <td class="font-semibold">Office Area</td>
                    <td>
                      {{guarantorTwo.ekyc.occupation.occupation_address.office_area}}
                    </td>
                  </tr>
                  <tr>
                    <td class="font-semibold">
                      Apt#/ House#/ Road#/ Village#
                    </td>
                    <td>
                      {{guarantorTwo.ekyc.occupation.occupation_address.address}}
                    </td>
                  </tr>
                  <tr>
                    <td class="font-semibold">Postal code</td>
                    <td>
                      {{guarantorTwo.ekyc.occupation.occupation_address.postal_code}}
                    </td>
                  </tr>
                </table>
              </div>
            </vx-card>
          </div>

          <div class="vx-col lg:w-1/2 w-full" >
            <vx-card title="Dependent Information" class="mb-base" >
              <template slot="actions">
                <vs-button color="rgb(0 121 193)"  icon-pack="feather" icon="icon-edit" @click="editDependentInfo(guarantorTwo.ekyc.id)">Update Dependent Information</vs-button>
              </template>
              <table class="vtable">
                <tr>
                  <td class="font-semibold">
                    No. of Children living with you
                  </td>
                  <td>&nbsp; &nbsp;{{ guarantorTwo.ekyc.dependent.number_of_child }}</td>
                </tr>
                <tr>
                  <td class="font-semibold">
                    No. of dependent living with you
                  </td>
                  <td>
                    &nbsp; &nbsp;{{ guarantorTwo.ekyc.dependent.number_of_dependent }}
                  </td>
                </tr>
                <br/>
              </table>
              <div  class="">
                <table  stripe   style="max-height: 235px; overflow: scroll; width: 100%">
                  <thead slot="thead">
                  <th>Relation</th>
                  <th>Name</th>
                  <th>Age</th>
                  </thead>
                  <tbody>
                  <tr
                    v-for="(dependent, indextr) in guarantorTwo.ekyc.dependent.depandant_details" :key="indextr">
                    <td>
                      {{ dependent.relation }}
                    </td>
                    <td>
                      {{ dependent.name }}
                    </td>
                    <td>
                      {{ dependent.age }}
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>

              <!--<div v-if="purchaseApp.status !== 5" class="vx-col w-full text-right">
                <vs-checkbox
                  v-model="guarantorList[indextr].gOneDependentCheck"
                  class="float-right"
                ></vs-checkbox>
                <vs-button
                  color="success"
                  class="mr-3 mb-2 float-right"
                  size="small"
                  @click="
                    updateDependentInfo(
                      guarantor.id,
                      guarantor.ekyc.id,
                      purchaseApp.id
                    )
                  "
                >Edit Dependent Information
                </vs-button>
              </div>-->

            </vx-card>
          </div>
        </div>
        <!-- Showroom and Product  -->

        <br/>

        <!--        Guarantor-->
      </div>

      <vx-card v-if="application.data.status === 7" title="Comments">
        <table class="vtable">
          <tr>
            <td class="font-semibold">
              Comment
            </td>
            <td>{{ application.data.comment }}</td>
          </tr>
          <tr>
            <td class="font-semibold">
              Invoice Number
            </td>
            <td v-if="application.data.status !== 7">
              {{ application.data.invoice_number }}
            </td>
            <td v-if="application.data.status === 7">
              <div class="demo-alignment" >
                <vs-input v-validate="'required|min:10|max:10'" data-vv-as="Invoice No" name="invoiceForUpdate"  @keypress="onlyNumber"
                          v-model="invoiceForUpdate" />
                <vs-button class="mr-3 mb-0" v-if="application.data.status === 7" @click="submitComment(appDetails.id, comment, invoiceForUpdate)">Update Invoice</vs-button>
              </div>
            </td>
          </tr>
          <br/>
        </table>
      </vx-card>
      <vx-card title="Submit your change to Head Office">
        <div class="vx-row">
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full mt-4">
                <span>Comment<sup>*</sup></span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-textarea class="w-full" type="text" v-model="suffix_comments" v-validate="'required'"
                          data-vv-as="Comments" name="suffix_comments"/>
                <span class="text-danger text-sm" v-show="errors.has('suffix_comments')">{{ errors.first('suffix_comments') }}</span>
              </div>
            </div>
          </div>

        </div>
        <!--<div class="vx-row">
          <div class="vx-col w-full">
            <template>
              <div>
                <vs-textarea pla v-model="comment" />
              </div>
            </template>
          </div>
        </div>-->
        <div class="vx-row">
          <div class=" w-full text-right">
            <vs-button class="mr-3 mb-2" :disabled="!validateForm" @click="submitChanges(suffix_comments)">Submit Changes</vs-button>
          </div>
        </div>
      </vx-card>

    </div>
    <br/>

  </div>
</template>
<script>
  import {mapGetters} from 'vuex'
  import vSelect from 'vue-select'
  import axios from '../axios'
  export default {
    data() {
      return {
        appDetails : {
          product_master:{},
          user:{
            ekyc:{
              parsonal:{},
              contact:{
                present_address:{
                  living_in_this_address:''
                },
                permanent_address:{
                  living_in_this_address:''
                }
              },
              occupation:{
                job_length:'',
                occupation_address:''
              },
              dependent:{},
            }
          },
          showroom:{

          }
        },
        comment:'',
        suffix_comments:'',
        invoiceNo:'',
        product:'',
        guarantorOne:'',
        guarantorTwo:'',
        popupActive: false,
        popupActive2: false,
        popupActive3: false,
        popupActive4: false,
        popupActive5: false,
        popupActive6: false,
        invoiceForUpdate:'',
        commentList:["Okey/No Observation", "Photoes are not clear", "Wrong Photo uploaded","Information Mismatch: Applicant","Information Mismatch: Guarantor","Contact with Head Office"]
      }
    },
    computed: {
      ...mapGetters(['application', 'applicationGuarantor']),
      validateForm() {
        return !this.errors.any()
          && this.suffix_comments !== ''
      }
    },
    async mounted () {
      await this.$store.dispatch('getApplication', this.$route.params.id);
      this.appDetails = this.application.data;
      this.invoiceNo = this.appDetails.invoice_number;
      this.comment = this.application.data.comment;
      this.product = this.application.data.product.product;
      this.guarantorOne = this.applicationGuarantor[0];
      this.guarantorTwo = this.applicationGuarantor[1];
      this.invoiceForUpdate = this.application.data.invoice_number;
      console.log("Details = ",this.application);
    },
    methods: {
      getOrderStatusColor (status) {
        if (status === 'on_hold') return 'warning'
        if (status === 'delivered') return 'success'
        if (status === 'canceled') return 'danger'
        return 'primary'
      },
      async submitChanges(suffix_comments) {
        const purchase = {
          id: this.$route.params.id,
          suffix_comments:suffix_comments
        };
        axios.put(`https://ho.butterflygroupbd.com/showroom-backend/api/showroomSubmitChangesForHo`, purchase).then((response)=>{
          console.log(response );
          this.$vs.notify({
            title: 'Updated',
            text: 'Contact Information Successfully Updated.',
            color: "success",
            position: 'top-right'
          })
          window.history.back();
        }).catch((error) =>{
          this.$vs.notify({
            title: 'Error!',
            text: 'Something went wrong.',
            color: "danger",
            position: 'top-right'
          })
        })


      },
      onlyNumber ($event) {
        //console.log($event.keyCode); //keyCodes value
        let keyCode = ($event.keyCode ? $event.keyCode : $event.which)
        if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) { // 46 is dot
          $event.preventDefault()
        }
      },
      isLetter (e) {
        let char = String.fromCharCode(e.keyCode)
        if (/^[A-Za-z\' '\.\-]+$/.test(char)) return true
        else e.preventDefault()
      },
      editContactInfo(ekyc_id){
        console.log("id=", ekyc_id);
        this.$router.push('/update-contact/'+ekyc_id).catch(() => {})
      },
      editOccupationInfo(ekyc_id){
        console.log("id=", ekyc_id);
        this.$router.push('/update-occupation/'+ekyc_id).catch(() => {})
      },
      editDependentInfo(ekyc_id){
        console.log("id=", ekyc_id);
        this.$router.push('/update-dependant/'+ekyc_id).catch(() => {})
      },
      editPersonalInfo(ekyc_id){
        console.log("id=", ekyc_id);
        this.$router.push('/update-personal/'+ekyc_id).catch(() => {})
      }
    },
    components: {
      'v-select': vSelect
    }
  }
</script>
<style>
  th {padding: 0}
  .not-data-table {
    display: none;
  }
  table.vtable {
    width: 100% !important;
  }
  .img-container.mb-4 img {
    height: 130px;
  }
  img.nidImg {
    height: 55px;
    cursor: zoom-in;
  }
  img.nidImgPrev {
    height: 275px;
    width: auto;
    border-radius: 7px;
  }
  sup {
    font-size: 16px;
    color: red;
  }
  .custom-title{
    padding: 10px 20px;
    background: #fff;
    border-radius: 0.5rem;
    box-shadow: 0px 4px 25px 0px rgb(0 0 0 / 10%);
    -webkit-transition: all .3s ease-in-out;
  }
  @media only screen

  and (min-device-width: 375px)

  and (max-device-width: 768px)

  and (-webkit-min-device-pixel-ratio: 2)

  and (orientation: portrait) {
    #page-user-view table td {
      font-size: 9pt;
    }
  }

  @media only screen

  and (min-device-width: 375px)

  and (max-device-width: 768px)

  and (-webkit-min-device-pixel-ratio: 2)

  and (orientation: landscape) {
    #page-user-view table td {
      font-size: 9pt;
    }
  }
</style>
